import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    timezone: {
      timezone_name: "",
      timezone_offset: 0,
      state: "",
    },
    status: "ready", // ready, loading, error, success,
    userId: null,
    forceRerender: true,
    searchData: {},
  },
  mutations: {
    authRequest(state) {
      state.status = "loading";
    },
    authSuccess(state, userId) {
      state.status = "success";
      state.userId = userId;
      state.searchData = {};
    },
    authError(state) {
      state.status = "error";
    },
    forceRerender(state) {
      state.forceRerender = !state.forceRerender;
    },
    logout(state) {
      state.status = "ready";
      state.searchData = {};
      state.timezone = {
        timezone_name: "",
        timezone_offset: 0,
        state: "",
      };
    },
    setSearchData(state, payload) {
      if (Object.keys(payload).length === 0) state.searchData = {};
      else state.searchData = { ...state.searchData, ...payload };
    },
    setTimezone(state, payload) {
      console.log("payload", payload);
      state.timezone = { ...state.timezone, ...payload };
    },
  },
  actions: {
    login({ commit }, { userId }) {
      commit("authRequest");
      commit("authSuccess", userId);
    },
    logout({ commit }) {
      localStorage.removeItem("vuex");
      localStorage.removeItem("token");
      sessionStorage.removeItem("token");
      commit("logout");
    },
    check_login({ commit }) {
      commit("authSuccess");
    },
  },
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
    }),
  ],
});
